import { useStorage } from '@vueuse/core'
import { supported, type LocaleCode, FALLBACK_LANG } from './langs'
import { STORAGE_KEYS } from '@/constants'

const { LANG } = STORAGE_KEYS
export const lang = useStorage<LocaleCode>(LANG, undefined)

// 把原始语言字符串规范化到受支持的 BCP-47 码（大小写/连字符/就近匹配）
export function normalizeToSupported(raw: string): LocaleCode | undefined {
  if (!raw) return
  const code = raw.trim().toLowerCase()
  const candidates = [code, code.replace('_', '-'), code.split('-')[0]]

  for (const c of candidates) {
    const canonical = c
      .split('-')
      .map((seg, i) => (i === 0 ? seg : seg.toUpperCase()))
      .join('-') as LocaleCode
    if (supported.has(canonical)) return canonical
  }

  // 语言级兜底映射（只有语言时映射到常用地区）
  const languageOnly = code.split('-')[0]
  const languageToExact: Partial<Record<string, LocaleCode>> = {
    en: 'en',
    zh: 'zh-CN',
    'zh-hk': 'zh-TW',
    'zh-mo': 'zh-TW',
    'zh-sg': 'zh-CN',
    ja: 'ja-JP',
    ko: 'ko-KR',
    th: 'th-TH',
    vi: 'vi-VN',
    ru: 'ru',
    ms: 'ms-MY',
    pt: 'pt-PT',
    fr: 'fr',
    es: 'es',
    de: 'de',
    tr: 'tr',
    fa: 'fa',
    id: 'id-ID',
    my: 'my-MM',
    ug: 'ug',
    hi: 'hi-IN',
    ar: 'ar',
  }
  const mapped = (languageToExact[languageOnly] ?? languageToExact[code]) as LocaleCode | undefined
  if (mapped && supported.has(mapped)) return mapped
  return
}

// 检测顺序——本地存储 → navigator.languages → navigator.language → 兜底
export function getInitialLocale(): LocaleCode {
  if (lang.value) return lang.value as LocaleCode
  const navList =
    navigator.languages && navigator.languages.length > 0
      ? navigator.languages
      : [navigator.language].filter(Boolean)

  for (const raw of navList) {
    const matched = normalizeToSupported(raw)
    if (matched) return matched
  }
  return FALLBACK_LANG
}
